/**
 * package: com.inq.ui
 * class: BalloonOverlaying
 * @extends com.inq.ui.Container 
 * @constructor
 */
com.inq.ui.BalloonOverlaying = function(id,styleName,element,text,parent) {
	com.inq.ui.Container.call(this);
	this._element = element;
	this._parent = parent;
	this._styleName = styleName;
	this._styleDef = null;
	this._text = text;
	this._parentContainer = parent;
	this.cornerRadius = 6;
	
	this._style = com.inq.utils.Util.getConfig(styleName,null);
	if(this._style == null) this._style = styleName == "BalloonNotify"?";color:white;background-color:navy;":styleName == "BalloonWarn"?";color:yellow;background-color:red;":";color:black;background-color:white;";
	
	this.render(this._parentContainer);
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.BalloonOverlaying, "com.inq.ui.BalloonOverlaying");

/**
 * _doClick
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private static function _doClick(e:Dynamic)
 * @private
 * @static
 * @param {null}  e 
 * @return {void}
 */
com.inq.ui.BalloonOverlaying._doClick = function(e) {
	/** @type {Window} */
	var win = window;
	/** @type {HTMLElement} */
	var ob = null != e ? e.target : win.event.srcElement;
	/** @type {com.inq.ui.BalloonOverlaying} */
	var c = ob.container;
	c.doClick();
};


/**
 * applyStyle
 *
 * $type TFun([],TEnum(Void,[]))
 * private override function applyStyle():Void
 * @override
 * @private
 * @this com.inq.ui.BalloonOverlaying
 * @return {void}
 */
com.inq.ui.BalloonOverlaying.prototype.applyStyle = function() {
	this.buildStyle();
};


/**
 * setID
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * override  public function setID(val:String):Void
 * @override
 * @public
 * @this com.inq.ui.BalloonOverlaying
 * @param {string}  val 
 * @return {void}
 */
com.inq.ui.BalloonOverlaying.prototype.setID = function(val) {
	com.inq.ui.Container.prototype.setID.call(this,val);
	if(this._img != null) this._img.id = val + "_img";
};


/**
 * setHandCursor
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setHandCursor(val:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.BalloonOverlaying
 * @param {string}  val
 */
com.inq.ui.BalloonOverlaying.prototype.setHandCursor = function(val) {
	/** @type {string} */
	var value = val;
	switch(value.toLowerCase()) {
		case "true":
			this._useHandCursor = true;
			break;
		case "false":
			this._useHandCursor = false;
			break;
		default:
			this._useHandCursor = false;
	}
	this.useHandCursor = this._useHandCursor?"true":"false";
};


/**
 * destroy
 *
 * $type TFun([],TDynamic(null))
 * public function destroy():Dynamic
 * @public
 * @this com.inq.ui.BalloonOverlaying
 * @return {null}
 */
com.inq.ui.BalloonOverlaying.prototype.destroy = function() {
	if(this._div.parentNode != null) try {
		this._div.parentNode.removeChild(this._div);
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}
	return this._element;
};


/**
 * buildStyle
 *
 * $type TFun([],TEnum(Void,[]))
 * override private function buildStyle():Void
 * @override
 * @private
 * @this com.inq.ui.BalloonOverlaying
 * @return {void}
 */
com.inq.ui.BalloonOverlaying.prototype.buildStyle = function() {
	this.render(this._parentContainer);
};


/**
 * doClick
 *
 * private function doClick()
 * @private
 * @this com.inq.ui.BalloonOverlaying
 * @return {void}
 */
com.inq.ui.BalloonOverlaying.prototype.doClick = function() {
	/** @type {com.inq.events.MouseEvent} */
	var ev = new com.inq.events.MouseEvent(com.inq.events.MouseEvent.CLICK);
	ev.target = this;
	ev.currentTarget = this;
	this.dispatchEvent(ev);
};


/**
 * _fixSizesAndPositions
 *
 * $type TFun([],TEnum(Void,[]))
 * private  function _fixSizesAndPositions():Void
 * @private
 * @this com.inq.ui.BalloonOverlaying
 * @return {void}
 */
com.inq.ui.BalloonOverlaying.prototype._fixSizesAndPositions = function() {
	/** @type {NodeList} */
	var els = this._div.getElementsByTagName("*");
	/** @type {HTMLElement} */
	var blnTable = this._div.getElementsByTagName("TABLE")[0];
	/** @type {?HTMLElement} */
	var blnSpanText = null;
	/** @type {?HTMLElement} */
	var blnCellText = null;
	/** @type {?HTMLElement} */
	var blnClearOverlay = null;
	/** @type {?HTMLElement} */
	var blnSpanCornerLT = null;
	/** @type {?HTMLElement} */
	var blnSpanCornerRT = null;
	/** @type {?HTMLElement} */
	var blnSpanCornerLB = null;
	/** @type {?HTMLElement} */
	var blnSpanCornerRB = null;
	/** @type {?HTMLElement} */
	var blnBackground = null;
	/** @type {?HTMLElement} */
	var blnBackgroundEW = null;
	/** @type {?HTMLElement} */
	var blnBackgroundNS = null;
	/** @type {?HTMLElement} */
	var blnLeftArrows = null;
	/** @type {?HTMLElement} */
	var blnRightArrows = null;
	/** @type {?HTMLElement} */
	var blnTopArrows = null;
	/** @type {?HTMLElement} */
	var blnBottomArrows = null;
	/** @type {?HTMLElement} */
	var blnUpArrowLeft = null;
	/** @type {?HTMLElement} */
	var blnUpArrowRight = null;
	/** @type {?HTMLElement} */
	var blnLeftArrowTop = null;
	/** @type {?HTMLElement} */
	var blnLeftArrowBottom = null;
	/** @type {?HTMLElement} */
	var blnTd1 = null;

	for (var i = 0, l = els.length; i < l; i++) {
		/** @type {HTMLElement} */
		var ob = els[i];
		if(ob == null) continue;
		/** @type {?string} */
		var nm = ob.getAttribute("name");
		
		if(nm != null && nm != "") switch(nm) {
			case "blnSpanText":
				blnSpanText = ob;
				break;
			case "blnCellText":
				blnCellText = ob;
				break;
			case "blnTd1":
				blnTd1 = els[i];
				break;
			case "blnSpanCornerLT":
				blnSpanCornerLT = ob;
				break;
			case "blnSpanCornerRT":
				blnSpanCornerRT = ob;
				break;
			case "blnSpanCornerLB":
				blnSpanCornerLB = ob;
				break;
			case "blnSpanCornerRB":
				blnSpanCornerRB = ob;
				break;
			case "blnBackground":
				blnBackground = ob;
				break;
			case "blnBackgroundEW":
				blnBackgroundEW = ob;
				break;
			case "blnBackgroundNS":
				blnBackgroundNS = ob;
				break;
			case "blnLeftArrows":
				blnLeftArrows = ob;
				break;
			case "blnRightArrows":
				blnRightArrows = ob;
				break;
			case "blnTopArrows":
				blnTopArrows = ob;
				break;
			case "blnBottomArrows":
				blnBottomArrows = ob;
				break;
			case "blnUpArrowLeft":
				blnUpArrowLeft = ob;
				break;
			case "blnUpArrowRight":
				blnUpArrowRight = ob;
				break;
			case "blnLeftArrowTop":
				blnLeftArrowTop = ob;
				break;
			case "blnClearOverlay":
				blnClearOverlay = ob;
				break;
			case "blnLeftArrowBottom":
				blnLeftArrowBottom = ob;
				break;
			default:
				haxe.Log.trace("item named " + nm + " not used",{ fileName : "BalloonOverlaying.hx", lineNumber : 397, className : "com.inq.ui.BalloonOverlaying", methodName : "_fixSizesAndPositions"});
		}
	}
	
	
	
	
	if (com.inq.ui.BalloonOverlaying.bIE6 && blnSpanCornerLT.offsetWidth > 18) {
		/** @type {number} */
		var p = 25;
		blnSpanCornerLT.style.fontSize = p + "pt";
		while(blnSpanCornerLT.offsetWidth > 18) {
			--p;
			blnSpanCornerLT.style.fontSize = p + "pt";
		}
		blnSpanCornerRB.style.fontSize = blnSpanCornerLB.style.fontSize = blnSpanCornerRT.style.fontSize = p + "pt";
		blnSpanCornerLT.style.left = "0px";
		blnSpanCornerLT.style.top = "0px";
		blnSpanCornerRT.style.left = "-8px";
		blnSpanCornerRT.style.top = "0px";
		blnSpanCornerLB.style.left = "0px";
		blnSpanCornerLB.style.top = "-8px";
		blnSpanCornerRB.style.left = "-8px";
		blnSpanCornerRB.style.top = "-8px";
		blnUpArrowLeft.style.top = "0px";
		blnUpArrowLeft.style.left = "-1px";
		blnUpArrowRight.style.top = "0px";
		blnUpArrowRight.style.left = "-1px";
	}
	
	blnLeftArrows.style.display = "";
	blnRightArrows.style.display = "none";
	blnTopArrows.style.display = "none";
	blnBottomArrows.style.display = "none";
	blnLeftArrowTop.style.display = "";
	blnLeftArrowBottom.style.display = "none";
	
	/* blnSpanCornerLT.style.fontSize = "16pt"; */
	/** @type {number} */
	var padding = Math.round(this.cornerRadius / 2);
	blnSpanText.parentNode.style.padding = padding + "px";
	/** @type {number} */
	var allArrowWidth = blnTable.offsetWidth - blnTd1.offsetWidth;

	/** @type {number} */
	var w = blnSpanText.offsetWidth;
	blnSpanText.parentNode.style.width = w + "px";
	/** @type {number} */
	var h = blnSpanText.offsetHeight;
	blnSpanText.parentNode.style.height = h + "px";
	
	h += padding * 2;
	w += padding * 2;
	
	blnTable.style.height = h + "px";
	blnTable.style.width = w + allArrowWidth + "px";
	
	blnBackground.style.width = w + "px";
	blnBackground.style.height = h + "px";
	blnBackgroundEW.style.left = "0px";
	blnBackgroundEW.style.right = "0px";
	blnBackgroundEW.style.top = this.cornerRadius + "px";
	blnBackgroundEW.style.bottom = "";
	blnBackgroundEW.style.height = h - 2 * this.cornerRadius + "px";
	blnBackgroundEW.style.width = w + "px";
	
	blnBackgroundNS.style.top = "0px";
	blnBackgroundNS.style.bottom = "";
	blnBackgroundNS.style.left = this.cornerRadius + "px";
	blnBackgroundNS.style.right = "";
	blnBackgroundNS.style.width = w - 2 * this.cornerRadius + "px";
	blnBackgroundNS.style.height = h + "px";
	
	
	blnSpanCornerRT.parentNode.style.left = w - this.cornerRadius + "px";
	blnSpanCornerRT.parentNode.style.right = "";
	blnSpanCornerRB.parentNode.style.left = w - this.cornerRadius + "px";
	blnSpanCornerRB.parentNode.style.right = "";
	blnSpanCornerRB.parentNode.style.top = h - this.cornerRadius + "px";
	blnSpanCornerRB.parentNode.style.bottom = "";
	blnSpanCornerLB.parentNode.style.top = h - this.cornerRadius + "px";
	blnSpanCornerLB.parentNode.style.bottom = "";
	
	
	this._div.style.width = blnTable.style.width;
	this._div.style.height = blnTable.style.height;
	blnClearOverlay.style.width = blnTable.style.width;
	blnClearOverlay.style.height = blnTable.style.height;
	for (var j = 0, len = els.length; j < len; j++) {
		var name = els[j].getAttribute("name");
		if (name != null && name != "") {
			switch (name) {
				case "blnArrowLeft":
					els[j].style.height = (els[j].tagName == "TABLE" ? h : h / 2) + "px";
					break;
				default:
					break;
			}
		}
	}
};


/**
 * render
 *
 * $type TFun([{ name => _parent, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private function render(_parent:Dynamic):Void
 * @private
 * @this com.inq.ui.BalloonOverlaying
 * @param {Element=}  _parent
 * @return {void}
 */
com.inq.ui.BalloonOverlaying.prototype.render = function (_parent) {
	/** @type {number} */
	var elementLeft = 0;
	/** @type {number} */
	var elementTop = 0;
	
	/* get the relative left and top to the parent */
	if (_parent == null) {
		_parent = window.document.body;
	}
	/** @type {?Element} */
	var o = this._element;
	while (o != _parent) {
		elementLeft += o.offsetLeft;
		elementTop += o.offsetTop;
		o = o.offsetParent;
		if (o == null) {
			break;
		}
	}
	elementTop += _parent.offsetTop;
	elementLeft += _parent.offsetLeft;
	
	/** @type {number} */
	var y = elementTop;
	/** @type {number} */
	var x = elementLeft + 3;
	
	/** @type {number} */
	var maxWidth = _parent.clientWidth;
	/** @type {number} */
	var pClientWidth = _parent.clientWidth;
	/** @type {number} */
	var blnWidth = maxWidth > 400 ? 400 : maxWidth;
	/** @type {number} */
	var toEdgeWidth = pClientWidth - com.inq.ui.BalloonOverlaying.HOT_OFFSET_X + x;

	/* Calculate the true left edge */
	/** @type {number} */
	var trueLeft = x - com.inq.ui.BalloonOverlaying.HOT_OFFSET_X;
	/** @type {number} */
	var trueTop = y - com.inq.ui.BalloonOverlaying.HOT_OFFSET_Y;

	if (toEdgeWidth < blnWidth) {
		blnWidth = toEdgeWidth;
	}
	/** @type {string} */
	var defaultStyle = this._style;

	this._div.innerHTML = "<span style=\"" + defaultStyle + "\">foo</span>";
	this._color = this._div.firstChild.style.backgroundColor;

	/** @type {string} */
	var _innerHTML = "<table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" align=\"left\" valign=\"top\" style=\"color:" + this._color + ";width:" + blnWidth + "px;border-style:none;border-width:0px;margin:0px;padding:0px;\">" + "<tbody>" + "<tr style=\"border-style:none;border-width:0px; margin:0px;padding:0px;\">" + "<td name=\"blnLeftArrows\" style=\"width:8px;border:0px; margin:0px; padding:0px\">" + "<table name=\"blnArrowLeft\" cellpadding=\"0\" width=\"8\" cellspacing=\"0\" border=\"0\" style=\"height:100%;width:8px;border:0px; margin:0px; padding:0px;\" height=\"100%\">" + "<tbody>" + "<TR name=\"blnArrowLeft\" width=\"8\" style=\"color:" + this._color + ";height:50%;border:0px;margin:0px;padding:0px;\">" + "<td width=\"8\" align=\"center\" valign=\"top\" style=\"border:0px; height:inherit; margin:0px; width:8px; \">" + "<div style=\"position:relative;top:" + this.cornerRadius + "px;left:0px;width:8px;height:9px;overflow:hidden;\">" + "<SPAN name=\"blnLeftArrowTop\" style=\"position:absolute;top:-3px;left:-2px;font-family:Arial;font-size:12px\">&#9668;<!-- left arrow --></span>" + "</div>" + "</TD>" + "</tr>";
	_innerHTML += "<TR name=\"blnArrowLeft\" width=\"8\" style=\"height:50%;border:0px; margin:0px; padding:0px;\">" + "<td width=\"8\" align=\"right\" valign=\"bottom\" style=\"border:0px; height:inherit; margin:0px; width:8px; \">" + "<div style=\"position:relative;height:100%;width:inherit;top:0px;left:0px;\">" + "<div style=\"position:absolute;bottom:" + this.cornerRadius + "px;left:0px;width:8px;height:9px;overflow:hidden;\">\n" + "<SPAN name=\"blnLeftArrowBottom\" style=\"position:absolute;top:-3px;left:-2px;color:" + this._color + ";font-family:Arial;font-size:12px\">&#9668;<!-- left arrow --></span>" + "</div>" + "</div>" + "</TD>" + "</tr>" + "</tbody>" + "</TABLE>" + "</td>";
	_innerHTML += "<td name=\"blnTd1\" align=\"left\" valign=\"top\" style=\"width:100%;margin-style:none;margin-width:0px;border:0px;padding:0px;\">" + "<table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" align=\"left\" valign=\"top\" width=\"100%\" style=\"width:100%;margin:0px;border:0px;padding:0px\">" + "<tbody>" + "<tr align=\"left\" valign=\"top\" style=\"margin:0px;border:0px;padding:0px\">" + "<TD name=\"blnTopArrows\" style=\"margin:0px;border:0px;padding:0px\">" + "<table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" height=\"8\" width=\"100%\" style=\"height:8px;border-style:none; border-width:0px;; margin:0px; padding:0px\">" + "<tbody style=\"border-style:none; border-width:0px;height:8px;margin:0px;padding:0px\">" + "<tr align=\"left\" valign=\"top\" style=\"border-style:none; border-width:0px;margin:0px;padding:0px\">\n" + "<td  width=\"50%\" align=\"left\" style=\"border-style:none; border-width:0px;margin:0px;padding:0px\">\n" + "<div style=\"position:relative;top:0px;left:" + this.cornerRadius + "px;width:8px;height:8px;overflow:hidden;\">" + "<span name=\"blnUpArrowLeft\" style=\"position:absolute;top:-3px;left:-2px;background-color:transparent; color:" + this._color + "; font-family:Arial; font-size:12px;font-style:normal;font-variant:normal;font-weight:normal;\">&#9650;<!-- up arrow --></span>" + "</div>" + "</td>" + "<td  width=\"50%\"  align=\"right\" style=\"margin:0px;border:0px;padding:0px\">" + "<div style=\"position:relative;top:0px;right:" + this.cornerRadius + "px;width:8px;height:8px;overflow:hidden;\">" + "<span name=\"blnUpArrowRight\" style=\"position:absolute;top:-3px;left:-2px;background-color:transparent; color:" + this._color + ";font-family:Arial; font-size:12px; font-style:normal; font-variant:normal; font-weight:normal; \">&#9650;<!-- up arrow --></span>" + "</div>" + "</td>" + "</TR>" + "</tbody>" + "</table>" + "</TD>" + "</TR>";
	_innerHTML += "<tr align=\"left\" valign=\"top\" style=\"width:100%;margin:0px;border:0px;padding:0px\">" + "<td width=\"100%\" height=\"100%\" align=\"left\" valign=\"top\" style=\"height:auto;margin:0px;border:0px;padding:0px\"  name=\"blnCellText\">" + "<div style=\"border-style:none; border-width:0px; height:100%; left:0px; position:relative; top:0px; width:100%;\">" + "<div style=\"background-color:transparent;width:100%;height:100%;position:absolute;left:0px;right:0px;\">" + "<div style=\"position:absolute;top:0px;left:0px;height:" + this.cornerRadius + "px;width:" + this.cornerRadius + "px;overflow:hidden;\">" + "<span name=\"blnSpanCornerLT\" style=\"color:" + this._color + "; ;position:absolute;margin:0px;left:-2px;top:-12px;font-family:Arial; font-size:28px;\">&#9679;<!-- UTF-25CF: Black Circle --></span>" + "</div>" + "<div  style=\"position:absolute;top:0px;right:0px;height:" + this.cornerRadius + "px;width:" + this.cornerRadius + "px;overflow:hidden;\">" + "<span name=\"blnSpanCornerRT\" style=\"color:" + this._color + "; position:absolute;margin:0px;left:-9px;top:-12px;font-family:Arial; font-size:28px;\">&#9679;<!-- UTF-25CF: Black Circle --></span>" + "</div>" + "<div style=\"position:absolute;bottom:0px;left:0px;height:" + this.cornerRadius + "px;width:" + this.cornerRadius + "px;overflow:hidden;\">" + "<span name=\"blnSpanCornerLB\" style=\"color:" + this._color + ";position:absolute;margin:0px;left:-2px;top:-18px;font-family:arial; font-size:28px;\">&#9679;<!-- UTF-25CF: Black Circle --></span>" + "</div>" + "<div style=\"position:absolute;bottom:0px;right:0px;height:" + this.cornerRadius + "px;width:" + this.cornerRadius + "px;overflow:hidden;\">" + "<span name=\"blnSpanCornerRB\" style=\"color:" + this._color + "; position:absolute;margin:0px;left:-9px;top:-18px;font-family:arial; font-size:28px;\">&#9679;<!-- UTF-25CF: Black Circle --></span>" + "</div>";
	_innerHTML += "<div name=\"blnBackground\" style=\"position:absolute;top:0px;bottom:0px;left:0px;right:0px;\">" + "<div style=\"background-color:" + this._color + ";\">" + "<div name=\"blnBackgroundEW\" style=\"position:absolute;top:" + this.cornerRadius + "px;bottom:" + this.cornerRadius + "px;left:0px;right:0px;background-color:" + this._color + ";\">" + "<div style=\"overflow: hidden; width:100%; height:100%;\"></div>" + "</div>" + "<div name=\"blnBackgroundNS\" style=\"position:absolute;top:0px;bottom:0px;left:" + this.cornerRadius + "px;right:" + this.cornerRadius + "px;background-color:" + this._color + ";\">" + "<div style=\"overflow: hidden; width:100%; height:100%;\"></div>" + "</div>" + "</div>" + "</div>" + "<div style=\"width:100%;position:absolute;top:0px;left:0px;border-style:none;border-width:0px;\">" + "<span name=\"blnSpanText\" class=\"box-contents\" style=\"background-color:transparent;font-family:Comic Sans MS; font-size:10pt; \">\n" + this._text + "</span>" + "</div>" + "</div>" + "</div>" + "</td>" + "</tr>";
	_innerHTML += "<tr style=\"margin:0px;border:0px;padding:0px\">" + "<td  name=\"blnBottomArrows\" style=\"margin:0px;border:0px;padding:0px\">" + "<table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" align=\"left\" valign=\"top\" width=\"100%\" style=\"border-style:none;border-width:0px;padding:0px;margin:0px;\">" + "<tbody>" + "<tr align=\"left\" valign=\"top\" style=\"border-color:#3d24e4; border-style:solid; border-width:0px;margin:0px;padding:0px\">" + "<td width=\"50%\" align=\"left\" valign=\"top\" style=\"border-color:#3d24e4; border-style:solid; border-width:0px;margin:0px;padding:0px\">" + "<div style=\"position:relative;top:0px;left:7px;width:8px;height:8px;overflow:hidden;\">" + "<span style=\"position:absolute;top:-4px;left:-2px;background-color:transparent;color:" + this._color + ";font-family:Arial;font-size:12px;font-style:normal;font-variant:normal;font-weight:normal;\">" + "&#9660;<!-- UTF-25BC: Black Down-Pointing Triangle -->" + "</span>" + "</div>" + "</td>" + "<td  width=\"50%\" align=\"right\" style=\"margin:0px;border:0px;padding:0px\">" + "<div style=\"position:relative;top:0px;right:7px;width:8px;height:8px;overflow:hidden;\">" + "<span  class=\"box-contents\" style=\"position:absolute;top:-4px;left:-2px;background-color:transparent;color:" + this._color + ";font-family:Arial;font-size:12px;font-style:normal;font-variant:normal;font-weight:normal; \">" + "&#9660;" + "</span>" + "</div>" + "</td>" + "</TR>" + "</tbody>" + "</table>" + "</td>" + "</tr>" + "</tbody>" + "</table>" + "</td>";
	_innerHTML += "<td name=\"blnRightArrows\" width=\"8\" style=\"border:0px; margin:0px; padding:0px;\">" + "<table name=\"blnArrowLeft\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" align=\"left\" valign=\"top\" width=\"8\" style=\"width:8px;border:0px; margin:0px; padding:0px;\">" + "<tbody>" + "<TR name=\"blnArrowLeft\" style=\"height:50%;width:8px;border:0px; margin:0px; padding:0px;\">" + "<td width=\"8\" align=\"center\" valign=\"top\" style=\"border:0px; height:inherit; margin:0px; max-width:8px; width:8px;\">" + "<div style=\"position:relative;top:" + this.cornerRadius + "px;left:0px;width:8px;height:9px;overflow:hidden;\">" + "<SPAN style=\"position:relative;top:-3px;left:-2px;color:" + this._color + ";font-family:Arial;font-size:12px\">" + "&#9658;<!-- right pointer -->" + "</span>" + "</div>" + "</TD>" + "</TR>" + "<TR name=\"blnArrowLeft\" width=\"8\" style=\"height:50%;width:8px;border:0px; margin:0px; padding:0px;\">" + "<td width=\"8\" align=\"center\" valign=\"bottom\" style=\"border:0px; height:inherit; margin:0px; max-width:8px; width:8px; \">" + "<div style=\"position:relative;height:100%;width:inherit;top:0px;left:0px;\">" + "<div style=\"position:absolute;bottom:" + this.cornerRadius + "px;left:0px;width:8px;height:9px;overflow:hidden;\">" + "<SPAN style=\"position:relative;top:-3px;left:-2px;color:" + this._color + ";font-family:Arial;font-size:12px\">" + "&#9658;<!-- right pointer -->" + "</span>" + "</div>" + "</div>" + "</TD>" + "</TR>" + "</tbody>" + "</TABLE>" + "</td>" + "</tr>" + "</tbody>" + "</TABLE>";
	_innerHTML += "<div name=\"blnClearOverlay\" style=\"position:absolute;top:0px;left:0px;width:100%;height:100%;cursor:pointer;\">" + "<input type=\"image\"  style=\"width:100%;height:100%;opacity:0.01;filter:alpha(opacity=1)\" />" + "</div>\n";
	this._div.innerHTML = _innerHTML;
	
	this._div.style.cssText = "z-index: 102;position:absolute;top: " + trueTop + "px;left: " + trueLeft + "px;color: " + this._color + ";background-color: transparent;width: " + blnWidth + "px;margin: 0px;";
	
	this._img = this._div.getElementsByTagName("input")[0];
	this._div.container = this;
	this._img.container = this;
	
	this._img.src = Application.application.getClearImage();
	this._img.onclick = com.inq.ui.BalloonOverlaying._doClick;
	
	if(this._div.parentNode == null) _parent.appendChild(this._div); else if(this._div.parentNode != _parent) {
		this._div.parentNode.removeChild(this._div);
		_parent.appendChild(this._div);
	}

	/** @type {HTMLCollection} */
	var contents = this._div.getElementsByTagName("SPAN");
	for (var i = 0, l = contents.length; i < l; i++) {
		if (contents[i].className == "box-contents") {
			contents[i].className = this._styleName;
			contents[i].style.cssText = defaultStyle + ";background-color:transparent";
		}
	}
	
	/* fix the sizing of all components */
	
	this._fixSizesAndPositions();
	this._div.style.left = trueLeft + "px";
	this._div.style.top = trueTop + "px";
};


/**
 * fixIERendering
 *
 * $type TFun([{ name => div, t => TDynamic(null), opt => false },{ name => color, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private function fixIERendering(div:Dynamic, color:String)
 * @private
 * @this com.inq.ui.BalloonOverlaying
 * @param {HTMLElement}  div
 * @param {string}  color 
 * @return {void}
 */
com.inq.ui.BalloonOverlaying.prototype.fixIERendering = function(div,color) {
	/** @type {number} */
	var h = div.childNodes[1].clientHeight;
	/** @type {number} */
	var w = div.childNodes[1].clientWidth;
	
	div.style.height = h + 13 + "px";
	/** @type {HTMLCollection} */
	var bg1 = div.getElementsByTagName("DIV");
	for (var i = 0, l = bg1.length; i < l; i++) {
		if (bg1[i].name == "balloon_background1") {
			bg1[i].style.height = (h - 40 < 0 ? 0 : h - 40) + "px";
			bg1[i].style.width = w + "px";
			if (color != null) bg1[i].style.backgroundColor = color;
			bg1[i].style.bottom = "";
			bg1[i].style.right = "";
		} else if (bg1[i].name == "balloon_background2") {
			bg1[i].style.height = h + "px";
			bg1[i].style.width = (w - 40 < 0 ? 0 : w - 40) + "px";
			if (color != null) bg1[i].style.backgroundColor = color;
			bg1[i].style.bottom = "";
			bg1[i].style.right = "";
		}
	}
};

/** @private @type {number} */
com.inq.ui.BalloonOverlaying.prototype.cornerRadius = null;
/** @private @type {com.inq.ui.Container} */
com.inq.ui.BalloonOverlaying.prototype._parentContainer = null;
/** @private @type {null} */
com.inq.ui.BalloonOverlaying.prototype._styleDef = null;
/** @private @type {string} */
com.inq.ui.BalloonOverlaying.prototype._styleName = null;
/** @private @type {string} */
com.inq.ui.BalloonOverlaying.prototype._color = null;
/** @private @type {string} */
com.inq.ui.BalloonOverlaying.prototype._text = null;
/** @private @type {null} */
com.inq.ui.BalloonOverlaying.prototype._element = null;
/** @type {null} */
com.inq.ui.BalloonOverlaying.prototype._img = null;
/** @private @type {boolean} */
com.inq.ui.BalloonOverlaying.prototype._useHandCursor = null;
/** @type {null} */
com.inq.ui.BalloonOverlaying.prototype.useHandCursor = null;
/** @type {com.inq.ui.BalloonOverlaying} */
com.inq.ui.BalloonOverlaying.prototype.__class__ = com.inq.ui.BalloonOverlaying;
/** @private @type {number} */
com.inq.ui.BalloonOverlaying.HOT_OFFSET_X = 0;

/** @private @type {number} */
com.inq.ui.BalloonOverlaying.HOT_OFFSET_Y = 0;

/** @private @type {string} */
com.inq.ui.BalloonOverlaying.CLASS_STYLE = "z-index:102;font-family:\"Comic Sans MS\";font-size:10pt;background-color:red; color:yellow;";

/** @private @type {boolean} */
com.inq.ui.BalloonOverlaying.bIE6 = window.navigator.appName == "Microsoft Internet Explorer" && (window.navigator.appVersion.indexOf("MSIE 6.0") >= 0 || window.navigator.appVersion.indexOf("MSIE 5.") >= 0);

